import React, { useState, useEffect, useRef } from 'react';
import {
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  Alert,
  Animated,
  ImageBackground,
  Image,
  Platform,
  ActivityIndicator,
  Linking,
  ScrollView,
} from 'react-native';
let MapView, Marker, PROVIDER_GOOGLE;
if (Platform.OS !== 'web') {
  const RNMaps = require('react-native-maps');
  MapView = RNMaps.default;
  Marker = RNMaps.Marker;
  PROVIDER_GOOGLE = RNMaps.PROVIDER_GOOGLE;
}
const isWeb = Platform.OS === 'web';
// Google Maps JS API for web
let GoogleMap, LoadScript, MarkerF, DirectionsRenderer;
if (Platform.OS === 'web') {
  const GMaps = require('@react-google-maps/api');
  GoogleMap = GMaps.GoogleMap;
  LoadScript = GMaps.LoadScript;
  MarkerF = GMaps.MarkerF;
  DirectionsRenderer = GMaps.DirectionsRenderer;
}
import { Ionicons } from '@expo/vector-icons';
import { useAuth } from '../../context/AuthContext';
import { useRide, DRIVER_MODE } from '../../context/RideContext';
import { LinearGradient } from 'expo-linear-gradient';
import { driverService } from '../../services/driverService';
import { API_BASE_URL } from '../../config/api';

const logoImage = require('../../../assets/obzidn-logo.png');
const logoSrc = Platform.OS === 'web'
  ? (typeof logoImage === 'string' ? logoImage : (logoImage && logoImage.default ? logoImage.default : '/obzidn-logo.png'))
  : null;

const GOOGLE_MAPS_API_KEY = 'AIzaSyD7c3Zwn9xAZ8byihOVxmMVIeczabqHLFU';

const DARK_MAP_STYLE = [
  { elementType: 'geometry', stylers: [{ color: '#212121' }] },
  { elementType: 'labels.icon', stylers: [{ visibility: 'off' }] },
  { elementType: 'labels.text.fill', stylers: [{ color: '#757575' }] },
  { elementType: 'labels.text.stroke', stylers: [{ color: '#212121' }] },
  { featureType: 'road', elementType: 'geometry', stylers: [{ color: '#2c2c2c' }] },
  { featureType: 'road', elementType: 'labels.text.fill', stylers: [{ color: '#8a8a8a' }] },
  { featureType: 'road.arterial', elementType: 'geometry', stylers: [{ color: '#373737' }] },
  { featureType: 'road.highway', elementType: 'geometry', stylers: [{ color: '#3c3c3c' }] },
  { featureType: 'road.highway.controlled_access', elementType: 'geometry', stylers: [{ color: '#4e4e4e' }] },
  { featureType: 'water', elementType: 'geometry', stylers: [{ color: '#000000' }] },
  { featureType: 'water', elementType: 'labels.text.fill', stylers: [{ color: '#3d3d3d' }] },
  { featureType: 'poi', stylers: [{ visibility: 'off' }] },
  { featureType: 'transit', stylers: [{ visibility: 'off' }] },
];

const DRIVER_MARKER_SVG = `<svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44">
  <circle cx="22" cy="22" r="20" fill="#000000" stroke="#D4AF37" stroke-width="2"/>
  <path d="M30 24l-1.5-4.5A2 2 0 0 0 26.6 18h-9.2a2 2 0 0 0-1.9 1.5L14 24v6a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1h10v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-6zm-13.5-1l1-3h9l1 3h-11zm-0.5 4a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm12 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z" fill="#ffffff"/>
</svg>`;

const PICKUP_MARKER_SVG = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" fill="#4CAF50" stroke="#fff" stroke-width="2"/><circle cx="12" cy="12" r="4" fill="#fff"/></svg>';
const DROPOFF_MARKER_SVG = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" fill="#F44336" stroke="#fff" stroke-width="2"/><circle cx="12" cy="12" r="4" fill="#fff"/></svg>';

const DRIVER_MARKER_ONLINE_SVG = `<svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44">
  <circle cx="22" cy="22" r="20" fill="#000000" stroke="#4CAF50" stroke-width="2"/>
  <path d="M30 24l-1.5-4.5A2 2 0 0 0 26.6 18h-9.2a2 2 0 0 0-1.9 1.5L14 24v6a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1h10v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-6zm-13.5-1l1-3h9l1 3h-11zm-0.5 4a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm12 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z" fill="#ffffff"/>
</svg>`;

const DRIVER_MARKER_OFFLINE_SVG = `<svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44">
  <circle cx="22" cy="22" r="20" fill="#000000" stroke="#F44336" stroke-width="2"/>
  <path d="M30 24l-1.5-4.5A2 2 0 0 0 26.6 18h-9.2a2 2 0 0 0-1.9 1.5L14 24v6a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1h10v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-6zm-13.5-1l1-3h9l1 3h-11zm-0.5 4a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm12 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z" fill="#ffffff"/>
</svg>`;

// Helper: render Google Map — skip LoadScript if API is already loaded
const renderWebMap = (children, loadingEl) => {
  if (typeof window !== 'undefined' && window.google?.maps) {
    return children;
  }
  return (
    <LoadScript googleMapsApiKey={GOOGLE_MAPS_API_KEY} loadingElement={loadingEl}>
      {children}
    </LoadScript>
  );
};

// Haversine distance in meters between two GPS coordinates
const getDistanceMeters = (lat1, lon1, lat2, lon2) => {
  const R = 6371000;
  const dLat = (lat2 - lat1) * Math.PI / 180;
  const dLon = (lon2 - lon1) * Math.PI / 180;
  const a = Math.sin(dLat / 2) ** 2 +
    Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
    Math.sin(dLon / 2) ** 2;
  return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
};

const STATUS_CONFIG = {
  ACCEPTED: { label: 'EN ROUTE TO PICKUP', color: '#4CAF50', icon: 'navigate' },
  ARRIVED: { label: 'WAITING FOR RIDER', color: '#FF9800', icon: 'time' },
  IN_PROGRESS: { label: 'TRIP IN PROGRESS', color: '#2196F3', icon: 'car-sport' },
};

const HomeScreen = ({ navigation }) => {
  const { user, logout } = useAuth();
  const {
    isOnline, location, lastGpsUpdate, debugLog,
    activeRide, driverMode, goOnline, goOffline,
    arriveAtPickup, startTrip, completeRide, cancelRide,
  } = useRide();

  const [earnings, setEarnings] = useState({ today: 0, week: 0 });
  const [completedRides, setCompletedRides] = useState(0);
  const [region, setRegion] = useState({
    latitude: 38.9072,
    longitude: -77.0369,
    latitudeDelta: 0.0922,
    longitudeDelta: 0.0421,
  });

  // Wallet state
  const [walletBalance, setWalletBalance] = useState(null);
  const [cashingOut, setCashingOut] = useState(false);

  // Active ride UI state
  const [actionLoading, setActionLoading] = useState(false);
  const [showCancelConfirm, setShowCancelConfirm] = useState(false);
  const [errorMsg, setErrorMsg] = useState(null);

  // Map dismiss — driver can close the map at any time
  const [mapDismissed, setMapDismissed] = useState(false);

  // Directions API route polyline
  const [directions, setDirections] = useState(null);
  const routeComputedRef = useRef(null);
  const autoTriggeredRef = useRef(null);
  const rideMapRef = useRef(null);

  // Animation values
  const fadeAnim = useRef(new Animated.Value(0)).current;
  const slideAnim = useRef(new Animated.Value(50)).current;
  const pulseAnim = useRef(new Animated.Value(1)).current;
  const glowAnim = useRef(new Animated.Value(0)).current;

  useEffect(() => {
    loadDriverData();

    Animated.parallel([
      Animated.timing(fadeAnim, { toValue: 1, duration: 800, useNativeDriver: true }),
      Animated.timing(slideAnim, { toValue: 0, duration: 600, useNativeDriver: true }),
    ]).start();

    startPulseAnimation();
    startGlowAnimation();
  }, []);

  // Fit map bounds to show all relevant markers
  const fitMapToRide = (map) => {
    if (!map || !activeRide || typeof window === 'undefined' || !window.google?.maps) return;
    const bounds = new window.google.maps.LatLngBounds();
    let hasPoints = false;
    if (location) {
      bounds.extend({ lat: location.latitude, lng: location.longitude });
      hasPoints = true;
    }
    if (activeRide.pickupLat && activeRide.pickupLng) {
      bounds.extend({ lat: parseFloat(activeRide.pickupLat), lng: parseFloat(activeRide.pickupLng) });
      hasPoints = true;
    }
    if (activeRide.dropoffLat && activeRide.dropoffLng) {
      bounds.extend({ lat: parseFloat(activeRide.dropoffLat), lng: parseFloat(activeRide.dropoffLng) });
      hasPoints = true;
    }
    if (hasPoints) {
      map.fitBounds(bounds, { top: 40, bottom: 40, left: 40, right: 40 });
    }
  };

  const onRideMapLoad = (map) => {
    console.log('[HomeScreen] Ride map loaded');
    rideMapRef.current = map;
    fitMapToRide(map);
  };

  // ─── In-App Directions (Directions API route polyline) ───
  useEffect(() => {
    if (!activeRide || mapDismissed) {
      setDirections(null);
      return;
    }
    const key = `${activeRide.id}-${activeRide.status}`;
    if (routeComputedRef.current === key) return;

    let attempt = 0;
    let timer = null;

    const computeRoute = () => {
      attempt++;
      if (typeof window === 'undefined' || !window.google?.maps) {
        console.log(`[HomeScreen] Directions: Google Maps not ready (attempt ${attempt})`);
        if (attempt < 5) { timer = setTimeout(computeRoute, 1500); }
        return;
      }
      const status = activeRide.status;
      let origin, dest;
      if (status === 'ACCEPTED') {
        if (!location) {
          console.log(`[HomeScreen] Directions: No GPS location yet (attempt ${attempt})`);
          if (attempt < 5) { timer = setTimeout(computeRoute, 1500); }
          return;
        }
        origin = { lat: location.latitude, lng: location.longitude };
        dest = { lat: parseFloat(activeRide.pickupLat), lng: parseFloat(activeRide.pickupLng) };
      } else if (status === 'IN_PROGRESS') {
        origin = { lat: parseFloat(activeRide.pickupLat), lng: parseFloat(activeRide.pickupLng) };
        dest = { lat: parseFloat(activeRide.dropoffLat), lng: parseFloat(activeRide.dropoffLng) };
      } else {
        return; // ARRIVED — no route needed, map still shows markers
      }
      if (!origin?.lat || !origin?.lng || !dest?.lat || !dest?.lng) {
        console.log('[HomeScreen] Directions: Invalid coordinates', origin, dest);
        return;
      }
      routeComputedRef.current = key;
      console.log('[HomeScreen] Directions: Computing route', status, origin, dest);
      const service = new window.google.maps.DirectionsService();
      service.route(
        { origin, destination: dest, travelMode: window.google.maps.TravelMode.DRIVING },
        (result, dirStatus) => {
          if (dirStatus === 'OK') {
            console.log('[HomeScreen] Directions: Route computed OK');
            setDirections(result);
          } else {
            console.warn('[HomeScreen] Directions: Route failed:', dirStatus);
          }
        }
      );
    };

    computeRoute();
    return () => { if (timer) clearTimeout(timer); };
  }, [activeRide?.id, activeRide?.status, mapDismissed, location]);

  // Reset UI state when a NEW ride starts (not on status change within same ride)
  useEffect(() => {
    setShowCancelConfirm(false);
    setActionLoading(false);
    setMapDismissed(false);
    setErrorMsg(null);
    routeComputedRef.current = null;
    autoTriggeredRef.current = null;
    rideMapRef.current = null;
  }, [activeRide?.id]);

  // Auto-trigger state transition when within 50m of target
  // Works regardless of mapDismissed — driver may be in Google Maps
  useEffect(() => {
    if (!location || !activeRide) return;
    const status = activeRide.status;
    let targetLat, targetLng;
    if (status === 'ACCEPTED') {
      targetLat = parseFloat(activeRide.pickupLat);
      targetLng = parseFloat(activeRide.pickupLng);
    } else if (status === 'IN_PROGRESS') {
      targetLat = parseFloat(activeRide.dropoffLat);
      targetLng = parseFloat(activeRide.dropoffLng);
    } else {
      return;
    }
    if (!targetLat || !targetLng) return;
    const dist = getDistanceMeters(location.latitude, location.longitude, targetLat, targetLng);
    if (dist <= 50) {
      const triggerKey = `${activeRide.id}-${status}`;
      if (autoTriggeredRef.current === triggerKey) return;
      autoTriggeredRef.current = triggerKey;
      console.log(`[HomeScreen] GPS proximity: ${dist.toFixed(0)}m from target, auto-triggering ${status}`);
      dismissMap();
      if (status === 'ACCEPTED') {
        arriveAtPickup();
      } else if (status === 'IN_PROGRESS') {
        completeRide();
      }
    }
  }, [location, activeRide]);

  // Refresh earnings when ride completes (activeRide goes null)
  useEffect(() => {
    if (!activeRide) {
      loadDriverData();
    }
  }, [activeRide]);

  // Update region when location changes from RideContext
  useEffect(() => {
    if (location) {
      setRegion({
        latitude: location.latitude,
        longitude: location.longitude,
        latitudeDelta: 0.01,
        longitudeDelta: 0.01,
      });
    }
  }, [location]);

  // Refresh earnings when screen regains focus
  useEffect(() => {
    const unsubscribe = navigation.addListener('focus', () => {
      loadDriverData();
    });
    return unsubscribe;
  }, [navigation]);

  // When driver returns from Google Maps (tab becomes visible again), refresh state
  useEffect(() => {
    if (!isWeb) return;
    const handleVisibility = () => {
      if (document.visibilityState === 'visible') {
        console.log('[HomeScreen] App regained focus — refreshing state');
        loadDriverData();
      }
    };
    document.addEventListener('visibilitychange', handleVisibility);
    return () => document.removeEventListener('visibilitychange', handleVisibility);
  }, []);

  const startPulseAnimation = () => {
    Animated.loop(
      Animated.sequence([
        Animated.timing(pulseAnim, { toValue: 1.1, duration: 1000, useNativeDriver: true }),
        Animated.timing(pulseAnim, { toValue: 1, duration: 1000, useNativeDriver: true }),
      ])
    ).start();
  };

  const startGlowAnimation = () => {
    Animated.loop(
      Animated.sequence([
        Animated.timing(glowAnim, { toValue: 1, duration: 2000, useNativeDriver: false }),
        Animated.timing(glowAnim, { toValue: 0, duration: 2000, useNativeDriver: false }),
      ])
    ).start();
  };

  const loadDriverData = async () => {
    try {
      try {
        const statsResponse = await driverService.getDriverStats();
        if (statsResponse.success) {
          setEarnings({
            today: statsResponse.data.todayEarnings || 0,
            week: statsResponse.data.weekEarnings || 0,
          });
          setCompletedRides(statsResponse.data.completedRides || 0);
        }
      } catch {
        setEarnings({ today: 0, week: 0 });
        setCompletedRides(0);
      }
      // Fetch wallet balance
      try {
        const walletResponse = await driverService.getWallet();
        if (walletResponse.success) {
          setWalletBalance(walletResponse.data.balance);
        }
      } catch {
        // Wallet is optional — silently fail
      }
    } catch (error) {
      console.error('Error loading driver data:', error);
    }
  };

  const toggleAvailability = async () => {
    if (isOnline) {
      await goOffline();
    } else {
      await goOnline();
    }
  };

  const handleQuickCashOut = async () => {
    if (walletBalance === null || walletBalance <= 0) return;
    const confirmed = isWeb
      ? window.confirm(`Cash out $${walletBalance.toFixed(2)} to your payment method?`)
      : true;
    if (!confirmed) return;
    setCashingOut(true);
    try {
      const response = await driverService.cashOut();
      if (response?.success) {
        if (isWeb) window.alert(response.message || `Cashed out $${response.data.amountCashedOut.toFixed(2)}`);
        loadDriverData();
      } else {
        if (isWeb) window.alert(response?.message || 'Cash out failed');
      }
    } catch (error) {
      if (isWeb) window.alert(error.response?.data?.message || 'Cash out failed');
    } finally {
      setCashingOut(false);
    }
  };

  const handleLogout = async () => {
    if (isWeb) {
      if (window.confirm('Are you sure you want to sign out?')) {
        try {
          await goOffline();
          await logout();
        } catch (error) {
          console.error('Logout error:', error);
        }
      }
    } else {
      Alert.alert('Sign Out', 'Are you sure you want to sign out?', [
        { text: 'Cancel', style: 'cancel' },
        {
          text: 'Sign Out',
          style: 'destructive',
          onPress: async () => {
            try {
              await goOffline();
              await logout();
            } catch (error) {
              console.error('Logout error:', error);
            }
          },
        },
      ]);
    }
  };

  // ─── Active Ride Handlers ───
  const showError = (msg) => {
    setErrorMsg(msg);
    setTimeout(() => setErrorMsg(null), 4000);
  };

  const handleArrive = async () => {
    setErrorMsg(null);
    setActionLoading(true);
    try {
      console.log('[HomeScreen] handleArrive: calling arriveAtPickup...');
      const result = await arriveAtPickup();
      console.log('[HomeScreen] handleArrive result:', JSON.stringify(result));
      setActionLoading(false);
      if (result.success) {
        dismissMap();
      } else {
        showError(result.message || 'Failed to mark arrival');
      }
    } catch (err) {
      console.error('[HomeScreen] handleArrive error:', err);
      setActionLoading(false);
      showError('Network error — check connection');
    }
  };

  const handleStartRide = async () => {
    setErrorMsg(null);
    setActionLoading(true);
    try {
      console.log('[HomeScreen] handleStartRide: calling startTrip...');
      const result = await startTrip();
      console.log('[HomeScreen] handleStartRide result:', JSON.stringify(result));
      setActionLoading(false);
      if (result.success) {
        routeComputedRef.current = null;
        rideMapRef.current = null; // force onLoad re-fit
        setMapDismissed(false);
      } else {
        showError(result.message || 'Failed to start trip');
      }
    } catch (err) {
      console.error('[HomeScreen] handleStartRide error:', err);
      setActionLoading(false);
      showError('Network error — check connection');
    }
  };

  const handleCompleteRide = async () => {
    setErrorMsg(null);
    setActionLoading(true);
    try {
      console.log('[HomeScreen] handleCompleteRide: calling completeRide...');
      const result = await completeRide();
      console.log('[HomeScreen] handleCompleteRide result:', JSON.stringify(result));
      setActionLoading(false);
      if (result.success) {
        dismissMap();
      } else {
        showError(result.message || 'Failed to complete ride');
      }
    } catch (err) {
      console.error('[HomeScreen] handleCompleteRide error:', err);
      setActionLoading(false);
      showError('Network error — check connection');
    }
  };

  const handleCancelRide = async () => {
    setShowCancelConfirm(false);
    setErrorMsg(null);
    setActionLoading(true);
    try {
      const result = await cancelRide();
      setActionLoading(false);
      if (result.success) {
        dismissMap();
      } else {
        showError(result.message || 'Failed to cancel ride');
      }
    } catch (err) {
      console.error('[HomeScreen] handleCancelRide error:', err);
      setActionLoading(false);
      showError('Network error — check connection');
    }
  };

  const handleCallRider = () => {
    const phone = activeRide?.rider?.phone;
    if (phone) {
      Linking.openURL(`tel:${phone}`);
    } else {
      if (isWeb) window.alert('Rider phone number is not available');
    }
  };

  // Close the in-app map preview
  const dismissMap = () => {
    setMapDismissed(true);
  };

  // Launch external Google Maps turn-by-turn navigation (Uber/Lyft style)
  const launchNavigation = (destLat, destLng) => {
    // Omit origin → Google Maps uses device GPS → triggers turn-by-turn mode
    const url = `https://www.google.com/maps/dir/?api=1&destination=${destLat},${destLng}&travelmode=driving&dir_action=navigate`;
    console.log('[HomeScreen] Launching Google Maps navigation:', url);
    if (isWeb) {
      window.open(url, '_blank');
    } else {
      Linking.openURL(url);
    }
  };

  const handleNavigate = () => {
    if (!activeRide) return;
    const status = activeRide.status;
    if (status === 'ACCEPTED' || status === 'ARRIVED') {
      const lat = parseFloat(activeRide.pickupLat);
      const lng = parseFloat(activeRide.pickupLng);
      if (lat && lng) launchNavigation(lat, lng);
    } else if (status === 'IN_PROGRESS') {
      const lat = parseFloat(activeRide.dropoffLat);
      const lng = parseFloat(activeRide.dropoffLng);
      if (lat && lng) launchNavigation(lat, lng);
    }
  };

  // ─── Active Ride UI ───
  const renderActiveRide = () => {
    const ride = activeRide;
    const status = ride.status;
    const statusConfig = STATUS_CONFIG[status] || { label: status, color: '#999', icon: 'help' };
    const fare = ride.fare || ride.estimatedFare || 0;
    const isPickupPhase = status === 'ACCEPTED' || status === 'ARRIVED';

    return (
      <View style={styles.activeRideContainer}>
        {/* Status Banner */}
        <LinearGradient
          colors={[statusConfig.color, statusConfig.color + 'CC']}
          style={styles.rideStatusBanner}
        >
          <Ionicons name={statusConfig.icon} size={22} color="#fff" />
          <Text style={styles.rideStatusText}>{statusConfig.label}</Text>
          <Text style={styles.rideStatusFare}>${parseFloat(fare).toFixed(2)}</Text>
        </LinearGradient>

        {/* Map — visible for all active phases, driver can dismiss */}
        {!mapDismissed && (
          <>
            <View style={styles.rideMapContainer}>
              {isWeb ? (
                renderWebMap(
                  <GoogleMap
                    onLoad={onRideMapLoad}
                    mapContainerStyle={{ width: '100%', height: '100%' }}
                    center={
                      location
                        ? { lat: location.latitude, lng: location.longitude }
                        : ride.pickupLat && ride.pickupLng
                          ? { lat: parseFloat(ride.pickupLat), lng: parseFloat(ride.pickupLng) }
                          : { lat: region.latitude, lng: region.longitude }
                    }
                    zoom={14}
                    options={{
                      styles: DARK_MAP_STYLE,
                      disableDefaultUI: true,
                      zoomControl: false,
                      gestureHandling: 'greedy',
                    }}
                  >
                    {location && (
                      <MarkerF
                        position={{ lat: location.latitude, lng: location.longitude }}
                        title="Your Location"
                        icon={{
                          url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(DRIVER_MARKER_SVG)}`,
                          scaledSize: { width: 44, height: 44 },
                          anchor: { x: 22, y: 22 },
                        }}
                      />
                    )}
                    {ride.pickupLat && ride.pickupLng && (
                      <MarkerF
                        position={{ lat: parseFloat(ride.pickupLat), lng: parseFloat(ride.pickupLng) }}
                        title="Pickup"
                        icon={{
                          url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(PICKUP_MARKER_SVG)}`,
                          scaledSize: { width: 24, height: 24 },
                          anchor: { x: 12, y: 12 },
                        }}
                      />
                    )}
                    {ride.dropoffLat && ride.dropoffLng && (
                      <MarkerF
                        position={{ lat: parseFloat(ride.dropoffLat), lng: parseFloat(ride.dropoffLng) }}
                        title="Destination"
                        icon={{
                          url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(DROPOFF_MARKER_SVG)}`,
                          scaledSize: { width: 24, height: 24 },
                          anchor: { x: 12, y: 12 },
                        }}
                      />
                    )}
                    {/* Route polyline from Directions API */}
                    {directions && (
                      <DirectionsRenderer
                        directions={directions}
                        options={{
                          suppressMarkers: true,
                          polylineOptions: {
                            strokeColor: '#D4AF37',
                            strokeWeight: 4,
                            strokeOpacity: 0.9,
                          },
                        }}
                      />
                    )}
                  </GoogleMap>,
                  <View style={styles.rideWebMap}>
                    <ActivityIndicator size="large" color="#D4AF37" />
                    <Text style={styles.rideWebMapStatus}>Loading map...</Text>
                  </View>
                )
              ) : (
                <MapView
                  style={styles.rideMap}
                  provider={PROVIDER_GOOGLE}
                  region={region}
                  showsUserLocation={true}
                  showsMyLocationButton={false}
                >
                  {location && (
                    <Marker coordinate={location} title="Your Location">
                      <View style={styles.driverMarkerActive}>
                        <Ionicons name="car" size={18} color="#fff" />
                      </View>
                    </Marker>
                  )}
                  {ride.pickupLat && ride.pickupLng && (
                    <Marker
                      coordinate={{ latitude: parseFloat(ride.pickupLat), longitude: parseFloat(ride.pickupLng) }}
                      title="Pickup"
                      description={ride.origin}
                      pinColor="#4CAF50"
                    />
                  )}
                  {ride.dropoffLat && ride.dropoffLng && (
                    <Marker
                      coordinate={{ latitude: parseFloat(ride.dropoffLat), longitude: parseFloat(ride.dropoffLng) }}
                      title="Destination"
                      description={ride.destination}
                      pinColor="#F44336"
                    />
                  )}
                </MapView>
              )}
            </View>
            {/* Map label */}
            <View style={styles.mapPreviewLabel}>
              <Ionicons name="eye-outline" size={14} color="rgba(255,255,255,0.5)" />
              <Text style={styles.mapPreviewLabelText}>ROUTE PREVIEW</Text>
            </View>
          </>
        )}

        {/* Route Info + Navigate Button */}
        <View style={styles.rideRouteCard}>
          <View style={styles.rideRouteRow}>
            <View style={[styles.rideRouteDot, { backgroundColor: '#4CAF50' }]} />
            <View style={styles.rideRouteInfo}>
              <Text style={styles.rideRouteLabel}>PICKUP</Text>
              <Text style={styles.rideRouteAddress} numberOfLines={2}>{ride.origin}</Text>
            </View>
          </View>
          <View style={styles.rideRouteDivider} />
          <View style={styles.rideRouteRow}>
            <View style={[styles.rideRouteDot, { backgroundColor: '#F44336' }]} />
            <View style={styles.rideRouteInfo}>
              <Text style={styles.rideRouteLabel}>DESTINATION</Text>
              <Text style={styles.rideRouteAddress} numberOfLines={2}>{ride.destination}</Text>
            </View>
          </View>
          {/* NAVIGATE — launches Google Maps turn-by-turn */}
          <TouchableOpacity
            style={styles.rideNavigateButton}
            onPress={handleNavigate}
            activeOpacity={0.7}
          >
            <Ionicons name="navigate" size={20} color="#fff" />
            <Text style={styles.rideNavigateText}>
              {isPickupPhase ? 'NAVIGATE TO PICKUP' : 'NAVIGATE TO DESTINATION'}
            </Text>
            <Ionicons name="open-outline" size={16} color="rgba(255,255,255,0.6)" />
          </TouchableOpacity>
          {/* Toggle embedded map preview */}
          <TouchableOpacity
            style={styles.rideMapToggle}
            onPress={() => {
              if (mapDismissed) {
                routeComputedRef.current = null;
                rideMapRef.current = null;
                setMapDismissed(false);
              } else {
                dismissMap();
              }
            }}
            activeOpacity={0.7}
          >
            <Ionicons name={mapDismissed ? 'map-outline' : 'close-circle-outline'} size={16} color="rgba(255,255,255,0.7)" />
            <Text style={styles.rideMapToggleText}>
              {mapDismissed ? 'SHOW MAP PREVIEW' : 'HIDE MAP PREVIEW'}
            </Text>
          </TouchableOpacity>
        </View>

        {/* Rider Info */}
        <View style={styles.rideRiderCard}>
          <View style={styles.rideRiderAvatar}>
            <Ionicons name="person" size={22} color="#D4AF37" />
          </View>
          <View style={styles.rideRiderDetails}>
            <Text style={styles.rideRiderName}>{ride.rider?.name || 'Rider'}</Text>
            {ride.rider?.phone && <Text style={styles.rideRiderPhone}>{ride.rider.phone}</Text>}
          </View>
          <TouchableOpacity style={styles.rideCallButton} onPress={handleCallRider}>
            <Ionicons name="call" size={18} color="#4CAF50" />
          </TouchableOpacity>
        </View>

        {/* Error banner */}
        {errorMsg && (
          <View style={styles.rideErrorBanner}>
            <Ionicons name="warning" size={16} color="#fff" />
            <Text style={styles.rideErrorText}>{errorMsg}</Text>
          </View>
        )}

        {/* Action Button */}
        <View style={styles.rideActionContainer}>
          {actionLoading ? (
            <View style={styles.rideLoadingButton}>
              <ActivityIndicator color="#fff" size="small" />
              <Text style={styles.rideLoadingText}>Processing...</Text>
            </View>
          ) : status === 'ACCEPTED' ? (
            <TouchableOpacity style={styles.ridePrimaryButton} onPress={handleArrive}>
              <LinearGradient colors={['#4CAF50', '#2E7D32']} style={styles.ridePrimaryGradient}>
                <Ionicons name="flag" size={22} color="#fff" />
                <Text style={styles.ridePrimaryText}>ARRIVED AT PICKUP</Text>
              </LinearGradient>
            </TouchableOpacity>
          ) : status === 'ARRIVED' ? (
            <TouchableOpacity style={styles.ridePrimaryButton} onPress={handleStartRide}>
              <LinearGradient colors={['#FF9800', '#F57C00']} style={styles.ridePrimaryGradient}>
                <Ionicons name="play" size={22} color="#fff" />
                <Text style={styles.ridePrimaryText}>START TRIP</Text>
              </LinearGradient>
            </TouchableOpacity>
          ) : status === 'IN_PROGRESS' ? (
            <TouchableOpacity style={styles.ridePrimaryButton} onPress={handleCompleteRide}>
              <LinearGradient colors={['#000', '#222']} style={styles.ridePrimaryGradient}>
                <Ionicons name="checkmark-done" size={22} color="#D4AF37" />
                <Text style={[styles.ridePrimaryText, { color: '#D4AF37' }]}>COMPLETE RIDE</Text>
              </LinearGradient>
            </TouchableOpacity>
          ) : null}
        </View>

        {/* Cancel Button */}
        {(status === 'ACCEPTED' || status === 'ARRIVED') && !showCancelConfirm && (
          <TouchableOpacity
            style={styles.rideCancelButton}
            onPress={() => setShowCancelConfirm(true)}
          >
            <Ionicons name="close-circle-outline" size={18} color="#F44336" />
            <Text style={styles.rideCancelText}>CANCEL RIDE</Text>
          </TouchableOpacity>
        )}

        {/* Cancel Confirmation */}
        {showCancelConfirm && (
          <View style={styles.rideCancelConfirm}>
            <Text style={styles.rideCancelConfirmText}>
              Cancel this ride? A $5 cancellation fee may apply.
            </Text>
            <View style={styles.rideCancelConfirmButtons}>
              <TouchableOpacity
                style={styles.rideCancelKeep}
                onPress={() => setShowCancelConfirm(false)}
              >
                <Text style={styles.rideCancelKeepText}>KEEP RIDE</Text>
              </TouchableOpacity>
              <TouchableOpacity
                style={styles.rideCancelYes}
                onPress={handleCancelRide}
              >
                <Text style={styles.rideCancelYesText}>YES, CANCEL</Text>
              </TouchableOpacity>
            </View>
          </View>
        )}
      </View>
    );
  };

  // ─── Idle UI (no active ride) ───
  const renderIdleUI = () => (
    <>
      {/* Availability Toggle */}
      <Animated.View
        style={[styles.availabilityCard, { opacity: fadeAnim, transform: [{ translateY: slideAnim }] }]}
      >
        <LinearGradient
          colors={isOnline ? ['#43a047', '#2e7d32'] : ['#1e1e1e', '#2d2d2d']}
          style={styles.availabilityGradient}
        >
          <View style={styles.availabilityHeader}>
            <View style={styles.availabilityInfo}>
              <Ionicons
                name={isOnline ? "radio-button-on" : "radio-button-off"}
                size={32}
                color={isOnline ? "#D4AF37" : "#888"}
              />
              <View style={styles.availabilityTextContainer}>
                <Text style={styles.availabilityTitle}>
                  {isOnline ? "You're Online" : "You're Offline"}
                </Text>
                <Text style={styles.availabilitySubtitle}>
                  {isOnline ? 'Accepting ride requests' : 'Tap to start accepting requests'}
                </Text>
              </View>
            </View>
            <Animated.View
              style={[
                styles.toggleButtonWrapper,
                !isOnline && {
                  shadowColor: glowAnim.interpolate({
                    inputRange: [0, 1],
                    outputRange: ['rgba(212, 175, 55, 0.3)', 'rgba(212, 175, 55, 0.9)']
                  }),
                  shadowOffset: {
                    width: 0,
                    height: glowAnim.interpolate({ inputRange: [0, 1], outputRange: [2, 8] })
                  },
                  shadowOpacity: glowAnim.interpolate({ inputRange: [0, 1], outputRange: [0.3, 0.9] }),
                  shadowRadius: glowAnim.interpolate({ inputRange: [0, 1], outputRange: [6, 20] }),
                  elevation: glowAnim.interpolate({ inputRange: [0, 1], outputRange: [6, 15] }),
                }
              ]}
            >
              <TouchableOpacity onPress={toggleAvailability} style={styles.toggleButton}>
                <LinearGradient
                  colors={isOnline ? ['#66bb6a', '#43a047'] : ['#D4AF37', '#B8860B', '#D4AF37']}
                  style={styles.toggleGradient}
                  start={{ x: 0, y: 0 }}
                  end={{ x: 1, y: 0 }}
                >
                  <Ionicons
                    name={isOnline ? "checkmark-circle" : "radio-button-off"}
                    size={22}
                    color="#000000"
                    style={{ marginRight: 8 }}
                  />
                  <Text style={styles.toggleText}>
                    {isOnline ? 'GO OFFLINE' : 'GO ONLINE'}
                  </Text>
                </LinearGradient>
              </TouchableOpacity>
            </Animated.View>
          </View>
        </LinearGradient>
      </Animated.View>

      {/* Stats Cards */}
      <Animated.View style={[styles.statsContainer, { opacity: fadeAnim }]}>
        <View style={styles.statCard}>
          <LinearGradient colors={['#1e1e1e', '#2d2d2d']} style={styles.statGradient}>
            <Ionicons name="cash" size={28} color="#D4AF37" />
            <Text style={styles.statValue}>${earnings.today.toFixed(2)}</Text>
            <Text style={styles.statLabel}>Today's Earnings</Text>
          </LinearGradient>
        </View>
        <View style={styles.statCard}>
          <LinearGradient colors={['#1e1e1e', '#2d2d2d']} style={styles.statGradient}>
            <Ionicons name="checkmark-circle" size={28} color="#4CAF50" />
            <Text style={styles.statValue}>{completedRides}</Text>
            <Text style={styles.statLabel}>Completed Rides</Text>
          </LinearGradient>
        </View>
        <View style={styles.statCard}>
          <LinearGradient colors={['#1e1e1e', '#2d2d2d']} style={styles.statGradient}>
            <Ionicons name="trending-up" size={28} color="#2196F3" />
            <Text style={styles.statValue}>${earnings.week.toFixed(2)}</Text>
            <Text style={styles.statLabel}>This Week</Text>
          </LinearGradient>
        </View>
      </Animated.View>

      {/* Wallet Balance Quick Card */}
      {walletBalance !== null && (
        <Animated.View style={[styles.walletCard, { opacity: fadeAnim }]}>
          <LinearGradient colors={['#1a1a2e', '#16213e']} style={styles.walletGradient}>
            <View style={styles.walletInfo}>
              <Ionicons name="wallet" size={22} color="#D4AF37" />
              <View style={styles.walletTextContainer}>
                <Text style={styles.walletLabel}>BALANCE</Text>
                <Text style={styles.walletAmount}>${walletBalance.toFixed(2)}</Text>
              </View>
            </View>
            <TouchableOpacity
              style={[styles.walletCashOut, (walletBalance <= 0 || cashingOut) && { opacity: 0.4 }]}
              onPress={handleQuickCashOut}
              disabled={walletBalance <= 0 || cashingOut}
            >
              {cashingOut ? (
                <ActivityIndicator color="#000" size="small" />
              ) : (
                <Text style={styles.walletCashOutText}>CASH OUT</Text>
              )}
            </TouchableOpacity>
          </LinearGradient>
        </Animated.View>
      )}

      {/* Map */}
      <Animated.View style={[styles.mapContainer, { opacity: fadeAnim }]}>
        {isWeb ? (
          renderWebMap(
            <GoogleMap
              mapContainerStyle={{ width: '100%', height: '100%' }}
              center={
                location
                  ? { lat: location.latitude, lng: location.longitude }
                  : { lat: region.latitude, lng: region.longitude }
              }
              zoom={15}
              options={{
                styles: DARK_MAP_STYLE,
                disableDefaultUI: true,
                zoomControl: true,
                gestureHandling: 'greedy',
              }}
            >
              {/* Driver car marker - green border when online, red when offline */}
              {location && (
                <MarkerF
                  position={{ lat: location.latitude, lng: location.longitude }}
                  title={isOnline ? 'Online' : 'Offline'}
                  icon={{
                    url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(isOnline ? DRIVER_MARKER_ONLINE_SVG : DRIVER_MARKER_OFFLINE_SVG)}`,
                    scaledSize: { width: 44, height: 44 },
                    anchor: { x: 22, y: 22 },
                  }}
                />
              )}
            </GoogleMap>,
            <View style={styles.webMapPlaceholder}>
              <ActivityIndicator size="large" color="#D4AF37" />
              <Text style={styles.webMapText}>Loading Map...</Text>
            </View>
          )
        ) : (
          <>
            <MapView
              style={styles.map}
              provider={PROVIDER_GOOGLE}
              region={region}
              showsUserLocation={true}
              showsMyLocationButton={false}
            >
              {location && (
                <Marker coordinate={location} title="Your Location" description="You are here">
                  <View style={[styles.driverMarker, { backgroundColor: isOnline ? '#4CAF50' : '#F44336' }]}>
                    <Ionicons name="car" size={20} color="#ffffff" />
                  </View>
                </Marker>
              )}
            </MapView>
          </>
        )}
      </Animated.View>

      {/* Debug Panel - Web Pilot */}
      {isWeb && (
        <View style={styles.debugPanel}>
          <Text style={styles.debugTitle}>PILOT DEBUG</Text>
          <Text style={styles.debugText}>API: {API_BASE_URL}</Text>
          <Text style={styles.debugText}>Status: {isOnline ? 'ONLINE' : 'OFFLINE'}</Text>
          <Text style={styles.debugText}>GPS: {location ? `${location.latitude.toFixed(4)}, ${location.longitude.toFixed(4)}` : 'No fix'}</Text>
          <Text style={styles.debugText}>Last Update: {lastGpsUpdate}</Text>
          <Text style={styles.debugText}>Log: {debugLog}</Text>
          <Text style={styles.debugText}>Active Ride: {activeRide ? activeRide.status : 'None'}</Text>
        </View>
      )}
    </>
  );

  return (
    <View style={styles.container}>
      <ImageBackground
        source={{ uri: 'https://images.unsplash.com/photo-1534430480872-3498386e7856?w=1920&q=80' }}
        style={styles.backgroundImage}
        blurRadius={4}
        resizeMode="cover"
        defaultSource={undefined}
      >
        <LinearGradient
          colors={['rgba(0,0,0,0.92)', 'rgba(10,10,20,0.88)', 'rgba(15,20,40,0.90)', 'rgba(10,15,35,0.92)']}
          style={styles.backgroundGradient}
        >
        {/* Header */}
        <LinearGradient
          colors={['rgba(0,0,0,0.95)', 'rgba(20,20,20,0.90)', 'rgba(30,30,30,0.85)']}
          start={{ x: 0, y: 0 }}
          end={{ x: 1, y: 0 }}
          style={styles.header}
        >
          <View style={styles.headerContent}>
            <View style={styles.headerLeft}>
              <View style={styles.logoContainer}>
                {isWeb ? (
                  <img src={logoSrc} alt="OBZIDN" style={{width: 44, height: 44, borderRadius: 22, objectFit: 'contain'}} />
                ) : (
                  <Image source={logoImage} style={styles.headerLogoImage} resizeMode="contain" />
                )}
                <Text style={styles.logoText}>OBZIDN</Text>
                <View style={styles.premiumBadge}>
                  <Text style={styles.premiumText}>LUXURY</Text>
                </View>
              </View>
              <View style={styles.greetingContainer}>
                <Text style={styles.greeting}>Hello, {user?.name || 'Driver'}</Text>
                <View style={styles.statusBadge}>
                  <Animated.View
                    style={[
                      styles.statusDot,
                      {
                        backgroundColor: activeRide ? '#2196F3' : (isOnline ? '#4CAF50' : '#F44336'),
                        transform: [{ scale: isOnline ? pulseAnim : 1 }]
                      }
                    ]}
                  />
                  <Text style={styles.statusText}>
                    {activeRide ? 'On a Ride' : (isOnline ? 'Online & Ready' : 'Currently Offline')}
                  </Text>
                </View>
              </View>
            </View>
            {!activeRide && (
              <TouchableOpacity onPress={handleLogout} style={styles.logoutButton}>
                <LinearGradient colors={['#ff6b6b', '#c92a2a']} style={styles.logoutButtonGradient}>
                  <Ionicons name="log-out-outline" size={22} color="#ffffff" />
                </LinearGradient>
              </TouchableOpacity>
            )}
          </View>
        </LinearGradient>

        <ScrollView
          style={{ flex: 1 }}
          contentContainerStyle={styles.scrollContent}
          showsVerticalScrollIndicator={false}
        >
          {driverMode === DRIVER_MODE.ACTIVE ? renderActiveRide() : renderIdleUI()}
        </ScrollView>
      </LinearGradient>
      </ImageBackground>
    </View>
  );
};

const styles = StyleSheet.create({
  container: { flex: 1, backgroundColor: '#0a0a0a' },
  backgroundImage: { flex: 1, width: '100%', height: '100%' },
  backgroundGradient: { flex: 1 },
  scrollContent: { paddingBottom: 30 },
  header: {
    paddingTop: 50, paddingBottom: 20, paddingHorizontal: 20,
    elevation: 8, shadowColor: '#000', shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.3, shadowRadius: 8,
  },
  headerContent: { flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' },
  headerLeft: { flex: 1 },
  logoContainer: { flexDirection: 'row', alignItems: 'center', marginBottom: 12 },
  headerLogoImage: { width: 44, height: 44, minWidth: 44, minHeight: 44, borderRadius: 22 },
  logoText: { fontSize: 24, fontWeight: '800', color: '#D4AF37', marginLeft: 12, letterSpacing: 3 },
  premiumBadge: {
    backgroundColor: 'rgba(212, 175, 55, 0.2)', paddingHorizontal: 8, paddingVertical: 3,
    borderRadius: 6, marginLeft: 10, borderWidth: 1, borderColor: '#D4AF37',
  },
  premiumText: { fontSize: 10, fontWeight: '800', color: '#D4AF37', letterSpacing: 1 },
  greetingContainer: { marginTop: 8 },
  greeting: { fontSize: 18, fontWeight: '600', color: '#ffffff', marginBottom: 6 },
  statusBadge: {
    flexDirection: 'row', alignItems: 'center', backgroundColor: 'rgba(255,255,255,0.1)',
    paddingHorizontal: 12, paddingVertical: 6, borderRadius: 20, alignSelf: 'flex-start',
  },
  statusDot: { width: 8, height: 8, borderRadius: 4, marginRight: 8 },
  statusText: { fontSize: 13, color: '#cccccc', fontWeight: '500' },
  logoutButton: { marginLeft: 12 },
  logoutButtonGradient: { width: 44, height: 44, borderRadius: 22, justifyContent: 'center', alignItems: 'center' },

  // ─── Idle UI styles ───
  availabilityCard: {
    marginHorizontal: 20, marginTop: 24, borderRadius: 16, overflow: 'hidden',
    elevation: 8, shadowColor: '#000', shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.3, shadowRadius: 8,
  },
  availabilityGradient: { padding: 20 },
  availabilityHeader: { flexDirection: 'column' },
  availabilityInfo: { flexDirection: 'row', alignItems: 'center', marginBottom: 16 },
  availabilityTextContainer: { marginLeft: 16, flex: 1 },
  availabilityTitle: { fontSize: 22, fontWeight: '700', color: '#ffffff', marginBottom: 4 },
  availabilitySubtitle: { fontSize: 14, color: 'rgba(255,255,255,0.8)', lineHeight: 20 },
  toggleButtonWrapper: { borderRadius: 14 },
  toggleButton: { borderRadius: 14, overflow: 'hidden' },
  toggleGradient: {
    paddingVertical: 16, paddingHorizontal: 28, alignItems: 'center',
    flexDirection: 'row', justifyContent: 'center',
  },
  toggleText: { fontSize: 16, fontWeight: '800', color: '#000000', letterSpacing: 1.5 },
  statsContainer: { flexDirection: 'row', paddingHorizontal: 16, marginTop: 24, gap: 12 },
  statCard: {
    flex: 1, borderRadius: 16, overflow: 'hidden',
    elevation: 6, shadowColor: '#000', shadowOffset: { width: 0, height: 3 },
    shadowOpacity: 0.25, shadowRadius: 6,
  },
  statGradient: { padding: 16, alignItems: 'center', minHeight: 120, justifyContent: 'center' },
  statValue: { fontSize: 24, fontWeight: '800', color: '#ffffff', marginTop: 8, marginBottom: 4 },
  statLabel: { fontSize: 11, color: 'rgba(255,255,255,0.7)', textAlign: 'center', fontWeight: '500', lineHeight: 16 },
  walletCard: {
    marginHorizontal: 20, marginTop: 16, borderRadius: 14, overflow: 'hidden',
    elevation: 6, shadowColor: '#000', shadowOffset: { width: 0, height: 3 },
    shadowOpacity: 0.25, shadowRadius: 6,
  },
  walletGradient: {
    flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between',
    paddingVertical: 16, paddingHorizontal: 20,
  },
  walletInfo: { flexDirection: 'row', alignItems: 'center' },
  walletTextContainer: { marginLeft: 12 },
  walletLabel: { fontSize: 10, color: 'rgba(255,255,255,0.5)', fontWeight: '700', letterSpacing: 1 },
  walletAmount: { fontSize: 22, fontWeight: '900', color: '#ffffff' },
  walletCashOut: {
    backgroundColor: '#D4AF37', paddingHorizontal: 20, paddingVertical: 10, borderRadius: 10,
  },
  walletCashOutText: { fontSize: 13, fontWeight: '800', color: '#000', letterSpacing: 1 },
  mapContainer: {
    marginHorizontal: 20, marginTop: 24, height: 280, borderRadius: 16, overflow: 'hidden',
    elevation: 8, shadowColor: '#000', shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.3, shadowRadius: 8, borderWidth: 2, borderColor: 'rgba(212, 175, 55, 0.3)',
  },
  map: { width: '100%', height: '100%' },
  webMapPlaceholder: {
    width: '100%', height: '100%', backgroundColor: '#1a1a2e',
    justifyContent: 'center', alignItems: 'center',
  },
  webMapText: { color: '#D4AF37', fontSize: 18, fontWeight: '700', marginTop: 12 },
  webMapSubtext: { color: '#999', fontSize: 13, marginTop: 6 },
  driverMarker: {
    borderRadius: 25, width: 50, height: 50, justifyContent: 'center', alignItems: 'center',
    borderWidth: 3, borderColor: '#ffffff', elevation: 5,
    shadowColor: '#000', shadowOffset: { width: 0, height: 2 }, shadowOpacity: 0.3, shadowRadius: 4,
  },
  debugPanel: {
    marginHorizontal: 20, marginTop: 20, backgroundColor: 'rgba(0, 255, 0, 0.1)',
    borderWidth: 1, borderColor: '#00ff00', borderRadius: 8, padding: 12,
  },
  debugTitle: { color: '#00ff00', fontWeight: '800', fontSize: 12, marginBottom: 4, letterSpacing: 1 },
  debugText: { color: '#00ff00', fontSize: 11, fontFamily: 'monospace', marginBottom: 2 },

  // ─── Active Ride styles ───
  activeRideContainer: {
    marginHorizontal: 16, marginTop: 16,
  },
  rideStatusBanner: {
    flexDirection: 'row', alignItems: 'center',
    paddingVertical: 14, paddingHorizontal: 20,
    borderRadius: 14, gap: 10, marginBottom: 12,
  },
  rideStatusText: {
    flex: 1, fontSize: 15, fontWeight: '800', color: '#fff', letterSpacing: 1,
  },
  rideStatusFare: { fontSize: 20, fontWeight: '900', color: '#fff' },
  rideMapContainer: {
    height: 200, borderRadius: 14, overflow: 'hidden',
    borderWidth: 2, borderColor: 'rgba(212, 175, 55, 0.3)',
  },
  mapPreviewLabel: {
    flexDirection: 'row', alignItems: 'center', justifyContent: 'center',
    paddingVertical: 6, marginTop: 4, marginBottom: 8, gap: 6,
  },
  mapPreviewLabelText: {
    color: 'rgba(255,255,255,0.5)', fontSize: 10, fontWeight: '700', letterSpacing: 1,
  },
  rideWebMap: {
    flex: 1, justifyContent: 'center', alignItems: 'center', padding: 20,
  },
  rideWebMapStatus: { color: '#fff', fontSize: 16, fontWeight: '800', marginTop: 8, letterSpacing: 1 },
  rideWebMapAddress: { color: 'rgba(255,255,255,0.7)', fontSize: 14, marginTop: 6, textAlign: 'center' },
  rideWebMapCoords: { color: 'rgba(255,255,255,0.4)', fontSize: 11, marginTop: 6, fontFamily: 'monospace' },
  rideMap: { width: '100%', height: '100%' },
  driverMarkerActive: {
    backgroundColor: '#000', borderRadius: 18, width: 36, height: 36,
    justifyContent: 'center', alignItems: 'center',
  },
  rideRouteCard: {
    backgroundColor: 'rgba(255,255,255,0.08)', borderRadius: 14, padding: 16, marginBottom: 12,
    borderWidth: 1, borderColor: 'rgba(255,255,255,0.1)',
  },
  rideRouteRow: { flexDirection: 'row', alignItems: 'center' },
  rideRouteDot: { width: 12, height: 12, borderRadius: 6, marginRight: 12 },
  rideRouteInfo: { flex: 1 },
  rideRouteLabel: { fontSize: 10, color: 'rgba(255,255,255,0.5)', fontWeight: '700', letterSpacing: 1, marginBottom: 2 },
  rideRouteAddress: { fontSize: 14, color: '#fff', fontWeight: '500' },
  rideRouteDivider: {
    width: 2, height: 16, backgroundColor: 'rgba(255,255,255,0.15)', marginLeft: 5, marginVertical: 4,
  },
  rideNavigateButton: {
    flexDirection: 'row', alignItems: 'center', justifyContent: 'center',
    marginTop: 14, paddingVertical: 14, borderRadius: 12,
    backgroundColor: '#2196F3', gap: 8,
  },
  rideNavigateText: { fontSize: 15, fontWeight: '800', color: '#fff', letterSpacing: 1, flex: 1, textAlign: 'center' },
  rideMapToggle: {
    flexDirection: 'row', alignItems: 'center', justifyContent: 'center',
    marginTop: 8, paddingVertical: 8, gap: 6,
  },
  rideMapToggleText: {
    color: 'rgba(255,255,255,0.5)', fontSize: 11, fontWeight: '600', letterSpacing: 0.5,
  },
  rideRiderCard: {
    flexDirection: 'row', alignItems: 'center',
    backgroundColor: 'rgba(255,255,255,0.08)', borderRadius: 14,
    padding: 14, marginBottom: 12,
    borderWidth: 1, borderColor: 'rgba(255,255,255,0.1)',
  },
  rideRiderAvatar: {
    width: 44, height: 44, borderRadius: 22, backgroundColor: 'rgba(212, 175, 55, 0.2)',
    justifyContent: 'center', alignItems: 'center', marginRight: 12,
    borderWidth: 1, borderColor: 'rgba(212, 175, 55, 0.4)',
  },
  rideRiderDetails: { flex: 1 },
  rideRiderName: { fontSize: 16, fontWeight: 'bold', color: '#fff', marginBottom: 2 },
  rideRiderPhone: { fontSize: 13, color: 'rgba(255,255,255,0.6)' },
  rideCallButton: {
    width: 42, height: 42, borderRadius: 21, backgroundColor: 'rgba(76, 175, 80, 0.15)',
    justifyContent: 'center', alignItems: 'center',
    borderWidth: 1, borderColor: 'rgba(76, 175, 80, 0.3)',
  },
  rideErrorBanner: {
    flexDirection: 'row', alignItems: 'center', gap: 8,
    backgroundColor: '#D32F2F', borderRadius: 10, padding: 12, marginBottom: 10,
  },
  rideErrorText: { color: '#fff', fontSize: 13, fontWeight: '600', flex: 1 },
  rideActionContainer: { marginBottom: 4 },
  ridePrimaryButton: { borderRadius: 14, overflow: 'hidden' },
  ridePrimaryGradient: {
    flexDirection: 'row', alignItems: 'center', justifyContent: 'center',
    paddingVertical: 18, gap: 10,
  },
  ridePrimaryText: { fontSize: 16, fontWeight: '800', color: '#fff', letterSpacing: 1 },
  rideLoadingButton: {
    backgroundColor: '#555', borderRadius: 14, paddingVertical: 18,
    alignItems: 'center', flexDirection: 'row', justifyContent: 'center', gap: 10,
  },
  rideLoadingText: { color: '#fff', fontSize: 14, fontWeight: '600' },
  rideCancelButton: {
    flexDirection: 'row', alignItems: 'center', justifyContent: 'center',
    paddingVertical: 14, marginTop: 8,
    borderRadius: 12, borderWidth: 2, borderColor: '#F44336',
    backgroundColor: 'rgba(244, 67, 54, 0.1)', gap: 8,
  },
  rideCancelText: {
    color: '#F44336', fontSize: 14, fontWeight: '800', letterSpacing: 1,
  },
  rideCancelConfirm: {
    marginTop: 8, backgroundColor: 'rgba(244, 67, 54, 0.1)',
    borderRadius: 12, padding: 16, borderWidth: 1, borderColor: 'rgba(244, 67, 54, 0.3)',
  },
  rideCancelConfirmText: {
    fontSize: 14, color: '#fff', textAlign: 'center', marginBottom: 14, lineHeight: 20,
  },
  rideCancelConfirmButtons: { flexDirection: 'row', gap: 12 },
  rideCancelKeep: {
    flex: 1, paddingVertical: 12, borderRadius: 10,
    backgroundColor: 'rgba(255,255,255,0.15)', alignItems: 'center',
  },
  rideCancelKeepText: { fontSize: 14, fontWeight: '700', color: '#fff' },
  rideCancelYes: {
    flex: 1, paddingVertical: 12, borderRadius: 10,
    backgroundColor: '#F44336', alignItems: 'center',
  },
  rideCancelYesText: { fontSize: 14, fontWeight: '700', color: '#fff' },
});

export default HomeScreen;
